<template>
<div :class="$style.root">
  <el-card  style="height: 98%;">
    <el-form
      label-position="left"
      label-width="80px"
      style="width:480px;"
      size="small"
      :model="form"
      :rules="formRules"
      :hide-required-asterisk="true"
      ref="form">
      <el-form-item label="测点" prop="stationcode" >
        <el-select
          v-model="form.stationcode"
          placeholder="请选择测点"
          :readonly="!isNew"
          style="width: 100%;">
            <el-option v-for="item in stationList" :key="item.FYCD" :label="item.FYNM" :value="item.FYCD">
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="开始时间" prop="stime">
        <el-date-picker
          v-model="form.stime"
          type="date"
          value-format="yyyy-MM-dd"
          style="width: 100%;"
          placeholder="选择开始时间">
        </el-date-picker>
      </el-form-item>

      <el-form-item label="结束时间" prop="etime">
        <el-date-picker
          v-model="form.etime"
          type="date"
          value-format="yyyy-MM-dd"
          style="width: 100%;"
          placeholder="选择结束时间">
        </el-date-picker>
      </el-form-item>

      <el-form-item label="单价" prop="unitprice">
        <el-input-number
          v-model="form.unitprice"
          controls-position="right"
          :precision="1"
          :min="1"
          :max="100">
        </el-input-number>
      </el-form-item>

      <el-form-item>
        <el-button icon="el-icon-circle-check-outline" type="primary" @click="submit('form')" :disabled="edited">提交</el-button>
        <el-button icon="el-icon-arrow-left" @click="$router.back()">返回</el-button>
      </el-form-item>
    </el-form>
  </el-card>
</div>
</template>

<script>
import {
  stationquery,
  setPeriodPrice
} from "@/apis/api";
import {PRICING_DATA_PERIOD_MODIFIED} from '../topics'

export default {
  props: {
    isNew: Boolean
  },
  data() {
    return {
      edited: false,
      form: {
        id: null,
        stationcode: null,
        // stationname: null,
        stime: null,
        etime: null,
        unitprice: null,
      },
      formRules: {
        stationcode: [
          { required: true, message: '请选择测点', trigger: 'change' }
        ],
        stime: [
          { required: true, regexp: /^\d{4}-\d{2}-\d{2}$/, message: '请选择开始时间' },
        ],
        etime: [
          { required: true, regexp: /^\d{4}-\d{2}-\d{2}$/, message: '请选择结束时间' },
        ],
        unitprice: [
          { required: true, type:'number', message: '请输入金额', trigger: 'change' }
        ],
      },
      regioncode: sessionStorage.getItem('regioncode'),
      stationList: [],
    }
  },
  computed: {
    selectedStationName() {
      if(!this.form.stationcode) {
        return null
      }
      return this.stationList.filter(item => item.FYCD === this.form.stationcode)[0].FYNM
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.form = Object.assign({}, vm.form, vm.$route.query)
    })
  },
  created() {
    if(this.isNew) {
      this.fetchStationList()
    } else {
      this.stationList.push({
        FYCD: this.$route.query.stationcode,
        FYNM: this.$route.query.stationname
      })
      this.form = Object.assign({}, this.form, this.$route.query)
    }
  },
  methods: {
    fetchStationList() {
      stationquery({regioncode: this.regioncode}).then(res => {
        this.stationList = res.result
      })
    },
    submit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          setPeriodPrice({
            stationcode: this.form.stationcode,
            stationname: this.selectedStationName,
            stime: this.form.stime,
            etime: this.form.etime,
            price: this.form.unitprice,
            userid: sessionStorage.getItem('userid')
          }).then(res => {
            this.$message({
              message: '操作成功',
              type: 'success'
            })
            this.edited = true
            this.$bus.$emit(PRICING_DATA_PERIOD_MODIFIED)
          }).catch(err => {
//          console.log(err)
            this.$message({
              message: '操作失败',
              type: 'danger'
            })
          })
        } else {
          return false
        }
      })
    }
  }

}
</script>

<style lang="less" module>
.root {
  :global(.el-form) {
    margin: 0 auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/sysmodule/waterfee/pricing/period-edit.vue